module.exports = __webpack_public_path__ + "static/media/p4.49f0e470.jpg";